import { useNavigate } from 'react-router-dom';
import { LelyButton } from '@/common/components';

function LogoutButton() {
  const navigate = useNavigate();

  const onLogoutClicked = () => {
    navigate('/logout', { replace: true });
  };

  return (
    <LelyButton
      variant="tertiary"
      onClick={onLogoutClicked}
      data-testid="btn-logout"
      leadingIcon="lely-icon-logout"
      fullWidth
    >
      Logout
    </LelyButton>
  );
}

export default LogoutButton;
